
import React, { useState, useEffect } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { db } from './../../Firebase'
import CircularProgress from '@material-ui/core/CircularProgress';
import { Typography } from '@material-ui/core';





export default function TablaFMI() {

    //Aca se cargan los posts
    const [rows, setRows] = useState(null)

    //Cargar la base de datos firebase al iniciar
    useEffect(() => {
        db.collection('Pruebas').doc('FMI2')
            .collection('indicadores')
            .doc('data')
            .onSnapshot(snapshot => {
                setRows(snapshot.data())
            }
            )
    }, [])


    return (

        < div className="fmi-table-container" >
            {rows ? (
                [
                    <TableContainer component={Paper} style={{ width: '100%' }}>
                        <Table size="small" aria-label="a dense table">

                            <TableBody>

                                {Object.keys(rows).sort().map((key) => (
                                    <TableRow key={key}>
                                        <TableCell component="th" scope="row" className="indicator">
                                            {key.substring(1)}
                                        </TableCell>
                                        <TableCell align="right">{rows[key]}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>,

                    <Typography variant='subtitle2' style={{
                        fontSize: 'smaller',
                        marginTop: '10px'
                    }}>
                        Fuentes: FMI, DANE y Banco de la República
                        </Typography>

                ]
            ) : (
                    <CircularProgress color="primary" />
                )}
        </div >
    );
}
